module.exports = __webpack_public_path__ + "static/img/image_solutions_optics_03.17c1deb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/solution/image_solutions_optics_03.png
// module id = Oap+
// module chunks = 10